export const taskTypes = [
  { key: "perform", label: "Perform" },
  { key: "witness", label: "Witness" },
  { key: "both", label: "Both" },
];

export const defaultInspectionWizardForm = {
  inspectionType: "all", // default to all agency inspections
  taskType: "perform", // default to perform
  inspYear: new Date().getFullYear().toString(), // default to current year as string
  approvalDate: "", // default to empty
};

// Configuration for RenderFields component
export const inspectionWizardFields = [
  {
    key: "inspectionType",
    label: "Inspection Type",
    type: "select",
    options: [{ value: "all", label: "All Available Inspections" }],
    required: true,
    // Options will be dynamically extended with agency tests
  },
  {
    key: "inspYear",
    label: "Inspection Year",
    type: "select",
    options: [
      {
        value: new Date().getFullYear().toString(),
        label: new Date().getFullYear().toString(),
      },
      {
        value: (new Date().getFullYear() + 1).toString(),
        label: (new Date().getFullYear() + 1).toString(),
      },
    ],
    required: true,
  },
  {
    key: "taskType",
    label: "Task Type",
    type: "select",
    options: taskTypes.map((type) => ({ value: type.key, label: type.label })),
    required: true,
  },
  {
    key: "approvalDate",
    label: "Approval Date",
    type: "date",
    required: false,
  },
];
